<div id="entities" class="page-layout simple fullwidth" wtfPerfectScrollbar>
    <!-- HEADER -->
    <div class="header mat-accent-bg p-24 h-160" fxLayout="row" fxLayoutAlign="start center">    
        <!-- APP TITLE -->
        <div class="logo my-12 m-sm-0" fxLayout="row" fxLayoutAlign="start center">    
            <button mat-icon-button>
                        <mat-icon class="mat-36" aria-label="Back">keyboard_arrow_left</mat-icon>
                </button>

                <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}"> {{title}}</span>
            </div>
            <!-- / APP TITLE -->
            <!-- Buttons -->
            <div class="toolbar-separator">
            </div>
            <div class="actions ng-tns-c65-453 ng-trigger ng-trigger-animate" fxlayout="row" fxlayoutalign="end center" ng-reflect-layout="row"
                ng-reflect-align="end center" style="flex-direction: row; box-sizing: border-box; display: flex; max-height: 100%; place-content: center flex-end; align-items: center;">
                <div class="btn-group">
                <ng-content select="button" class="add-entity-button mat-white-bg my-12 mt-sm-0"></ng-content>
            </div>
        </div>
        <!-- /Buttons -->
    </div>
    <!-- / HEADER -->
    <!-- CONTENT -->
    <div class="content p-24 mat-white-bg">
        <ng-content></ng-content>

    </div>
</div>
